import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import GiftcardDetailsHeaderWeb from "./layouts/GiftcardDetailsHeader.web";
import GiftcardDetailsHeaderMob from "./layouts/GiftcardDetailsHeader.mob";

const GiftcardDetailsHeaderComponent = withConditionalComponent(GiftcardDetailsHeaderWeb, GiftcardDetailsHeaderMob);

type Props = {
  brandName?: string;
  isFetching?:boolean;
};

const GiftcardDetailsHeader: FC<Props> = ({ brandName, isFetching }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <GiftcardDetailsHeaderComponent trigger={isLargeScreen} props={{ brandName, isFetching }} />;
};

export default GiftcardDetailsHeader;
